<template>
  <div class="projectlist">
    <div class="proinfo">
      <div style="height:1rem"></div>
      <div class="info_header">
        <div class="title">{{ proInfo.title }}</div>
        <div class="pro_dec">{{ proInfo.describe }}</div>
        <div class="pro_tag">#{{ proInfo.cateName }}</div>
      </div>
      <div class="numlook">已展示{{ lookshow }}次， {{ likeNum }}人感兴趣</div>
      <div class="pro_main">
        <div class="proUserinfo">
          <div class="user_head">
            <img :src="proUser.avatar" />
          </div>
          <div class="user_names">
            <p>{{ proUser.nickname }}</p>
            <p>#{{ proUser.demand_name }}</p>
          </div>
          <span class="lookNum" @click="addEwm">+ 微信</span>
        </div>
        <div class="pro_content">
          <div class="pro_title">项目介绍</div>
          <div class="pro_dec">
            <div class="pro_text">{{ pro_text }}</div>
            <div class="pro_imgs">
              <img :src="item" v-for="(item, index) in pro_img" :key="index" />
            </div>
          </div>
        </div>
        <div class="lookPeople">
          <div class="headLook" v-for="(item, index) in lookView" :key="index">
            <div class="headBox">
              <img :src="item.avatar" /><span>{{ item.nickname }}</span>
            </div>
            <span class="lookText" v-if="item.type == 1">正在关注这个项目</span>
            <span class="lookText" v-if="item.type == 2">对这个项目感兴趣</span>
            <span class="lookText" v-if="item.type == 3"
              >获取了项目发起人的联系方式</span
            >
          </div>
        </div>
      </div>
    </div>
    <div style="height: 1.5rem;"></div>
    <div class="footerBtn">
      <div class="indexbtn">
        <router-link :to="{ path: '/' }">首页</router-link>
      </div>
      <div class="fabuBtn" @click="call(proUser.phone)">打招呼</div>
    </div>
    <!-- 二维码 -->
    <div
      class="dialog_MC ewmDialog"
      v-if="showEwmDialog"
      @click="hideEwmDialog1"
    >
      <div>
        <img :src="proUser.wx_qr_code" />
        <p>识别二维码添加，可咨询</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { getShare, getProjectDetailsNew } from "@api/public";
import { cookie } from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
let vm = null;
export default {
  name: "projectInfo",
  components: {},
  props: {},
  data: function() {
    return {
      proId: "",
      proInfo: "",
      proUser: "",
      pro_text: "",
      pro_img: [],
      showEwmDialog: false,
      lookView: [],
      lookshow: 0,
      likeNum: 0
    };
  },
  created() {
    vm = this;
  },
  watch: {},
  mounted: function() {
    this.proId = this.$route.query.projectid;
    this.getProjectDetailsNew();
    this.setOpenShare();
  },
  methods: {
    // 获取项目详情
    getProjectDetailsNew() {
      // 获取项目项目
      var data = "?project_id=" + this.proId;
      getProjectDetailsNew(data).then(res => {
        console.log("1:", typeof res.data.info);
        console.log("2:", typeof res.data.userInfo);
        this.proInfo = res.data.info;
        this.proUser = res.data.userInfo;
        this.lookView = res.data.views;
        this.lookshow = res.data.views_count;
        this.likeNum = res.data.views_interested;
        this.pro_text = JSON.parse(res.data.info.details).text;
        if (JSON.parse(res.data.info.details).img == "") {
        } else {
          this.pro_img = JSON.parse(res.data.info.details).img.split(",");
        }
        console.log("this.pro_img：", this.pro_img);
      });
    },
    // 打招呼
    call(tel) {
      if (tel == "" || tel == undefined || tel == "undefined") {
        return Toast("发起人暂未提供手机号");
      } else {
        window.location.href = "tel://" + tel;
      }
    },
    addEwm() {
      if (
        this.proUser.wx_qr_code == "" ||
        this.proUser.wx_qr_code == null ||
        this.proUser.wx_qr_code == undefined ||
        this.proUser.wx_qr_code == "null" ||
        this.proUser.wx_qr_code == "undefined"
      ) {
        Toast("发起人暂未提供Ta的微信");
      } else {
        this.showEwmDialog = true;
      }
    },
    hideEwmDialog1() {
      this.showEwmDialog = false;
    },
    setOpenShare() {
      var that = this;
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: that.proInfo.describe,
            title: that.proInfo.title,
            link: location.href,
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>

<style>
body,
html {
  background-color: #fff !important;
}
.projectlist {
  position: relative;
  width: 100%;
  background: url(https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_bg_project.png)
    no-repeat;
  background-size: 100% auto;
}
.proinfo {
  width: 94%;
  margin: 0 auto;
}
.info_header {
  width: 92%;
  border-bottom: 0.01rem solid #f0f0f0;
  margin: 0 auto;
  padding: 0.2rem 0.3rem;
  background: #fff;
  position: relative;
}
.title {
  width: 100%;
  font-size: 0.42rem;
  color: #000;
}
.pro_dec {
  font-size: 0.28rem;
  color: #666;
  margin-top: 0.4rem;
  line-height: 1.8;
}
.pro_tag {
  font-size: 0.24rem;
  color: #999;
  margin-top: 0.2rem;
}
.pro_main {
  margin-top: 0.4rem;
  position: relative;
}
.proUserinfo {
  width: 94%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  position: relative;
  padding: 0.4rem 0;
  border-top: 0.02rem solid #f0f0f0;
  border-bottom: 0.02rem solid #f0f0f0;
}
.user_head {
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 100%;
  overflow: hidden;
}
.user_head img {
  display: block;
  width: 100%;
}
.user_names {
  width: calc(100% - 2.5rem);
  margin-left: 0.2rem;
}
.user_names p:nth-of-type(1) {
  font-size: 0.26rem;
  color: #333;
}
.user_names p:nth-of-type(2) {
  font-size: 0.24rem;
  color: #666;
  margin-top: 0.2rem;
}
.lookNum {
  position: absolute;
  font-size: 0.22rem;
  right: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  color: #fff;
  background-color: #ff410a;
  display: block;
  width: 1.3rem;
  border: 0.02rem solid #ff410a;
  text-align: center;
  line-height: 0.54rem;
  border-radius: 0.12rem;
}
.numlook {
  background-color: #fce4b6;
  line-height: 0.77rem;
  color: #361900;
  font-size: 0.26rem;
  width: 94%;
  margin: 0.4rem auto 0;
  text-align: center;
}
.pro_content {
  width: 94%;
  margin: 0.4rem auto;
}
.pro_title {
  font-size: 0.28rem;
  color: #000;
  line-height: 0.8rem;
}
.pro_text {
  font-size: 0.28rem;
  line-height: 2;
}
.pro_imgs {
  width: 100%;
}
.pro_imgs img {
  display: block;
  width: 100%;
}
.footerBtn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0.15rem 0 0.25rem;
  background-color: #fff;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.indexbtn {
  width: 20%;
  text-align: center;
  line-height: 0.8rem;
  font-size: 0.32rem;
  color: #000;
}
.indexbtn a {
  color: #000;
}
.fabuBtn {
  width: 80%;
  text-align: center;
  line-height: 0.8rem;
  background-color: #ff4d19;
  font-size: 0.32rem;
  color: #fff;
}
.fabuBtn a {
  color: #ffffff;
}
.dialog_MC {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.7);
}
.ewmDialog div {
  position: absolute;
  display: block;
  width: 4rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 0.2rem;
  text-align: center;
  border-radius: 0.15rem;
}
.ewmDialog img {
  display: block;
  width: 80%;
  margin: 0 auto 0.3rem;
}
.ewmDialog p {
  font-size: 0.24rem;
  text-align: center;
  width: 100%;
}
.lookPeople {
  margin: 0.3rem auto;
  width: 94%;
}
.headLook {
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center;
  padding: 0.15rem 0;
}
.headBox {
  display: flex;
  position: relative;
  align-items: center;
  position: relative;
}
.headBox img {
  display: block;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 100%;
  margin-right: 0.2rem;
}
.headBox span {
  color: #000;
  font-size: 0.28rem;
}
.lookText {
  color: #666;
  font-size: 0.28rem;
}
</style>
